import { inject, Injectable } from '@angular/core';
import { EbbAuthService } from '@app/browser-extension/services/ebb-auth.service';
import { LocalizationService } from '@degreed/lxp/services';

@Injectable()
export class ExtensionLocalizationService extends LocalizationService {
  private ebbAuthService: EbbAuthService = inject(EbbAuthService);

  public get userExtensionLocale(): string {
    const supportedIds = [
      ...this.localeIds.map((l) => l.toLowerCase()),
      'en-JM',
      'fr-CA',
    ];
    const userLocale = this.ebbAuthService.authUserLocale;
    const isSupportedLocale =
      supportedIds.includes(userLocale) ||
      supportedIds.includes(userLocale?.split('-')[0]);
    if (userLocale && !isSupportedLocale) {
      return this.defaultLocale;
    }
    return userLocale || this.defaultLocale;
  }
}
